<script>
export default {
  props: {
    selectedTabKey: String,
    tabs: Array
  },
  computed: {
    selectedTabIndex () {
      const index = this.tabs.findIndex(tab => tab.key === this.$props.selectedTabKey)

      return index > 0 ? index : 0
    }
  },
  methods: {
    updateTab (key) {
      this.$emit('tabChange', key)
    }
  }
}
</script>

<template>
  <v-tabs :value="selectedTabIndex">
    <v-tab
      v-for="tab, index in tabs"
      :key="index"
      style="line-height: 1.5; font-size: 14px;"
      @click="updateTab(tab.key)"
    >
      {{ tab.label }}
    </v-tab>
  </v-tabs>
</template>
